import * as React from 'react';
import config from '../config/config';
import { useNavigate } from "react-router-dom";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';

import { Input } from './../components/form/Input';
import { MaskedTextBox } from './../components/form/MaskedTextBox';
import { DropDownList } from './../components/form/DropDownList';
import { Switch } from './../components/form/Switch';

import { requiredValidator, emailValidator, phoneValidator } from './../validators';
import { AppContext } from '../AppContext';

const title = ['Herr', 'Frau', 'Dr.', 'Prof.'];

const CreateCustomers = () => {
    const history = useNavigate();
    const { showNotification } = React.useContext(AppContext);

    const onSubmit = React.useCallback(async (dataItem) => {
        try {
            // Debugging: Ausgabe der Formulardaten vor dem Senden
            console.log('Formulardaten:', dataItem);

            const customerData = {
                'Firma': dataItem.companyName,
                'Strasse': dataItem.streetName,
                'Hausnummer': dataItem.streetNumber,
                'PLZ': dataItem.PLZ,
                'ORT': dataItem.cityName,
                'Titel': dataItem.customer,
                'Vorname': dataItem.firstName,
                'Nachname': dataItem.lastName,
                'Funktion': dataItem.function,
                'Telefonnummer': dataItem.phoneNumber,
                'EmailAdresse': dataItem.email,
                'Active': dataItem.isInPublicDirectory ? 'true' : 'false',
                'PrivateCustomer': dataItem.isPrivateCustomer ? 'true' : 'false', // Neues Feld
            };

            // Debugging: Ausgabe der gesendeten Daten
            console.log('Gesendete Daten:', customerData);

            const response = await fetch(`${config.host}/customers`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(customerData),
            });

            if (response.ok) {
                const result = await response.json();
                showNotification('success', `Kunde erfolgreich angelegt! Kunden-ID: ${result['Customer-ID']}`);
                history('/customers');
            } else {
                const error = await response.json();
                showNotification('error', `Fehler beim Erstellen des Kunden: ${error.error}`);
            }
        } catch (err) {
            showNotification('error', `Es ist ein Fehler aufgetreten: ${err.message}`);
        }
    }, [history, showNotification]);

    const onCancelClick = React.useCallback(() => {
        history('/customers');
    }, [history]);

    const handlePrivateCustomerChange = (event, formRenderProps) => {
        const isPrivate = event.value;
        if (isPrivate) {
            formRenderProps.onChange('companyName', { value: 'PRIVATKUNDE' });
        } else {
            formRenderProps.onChange('companyName', { value: '' });
        }
    };

    return (
        <div id="CreateCustomers" className="profile-page main-content">
            <div className="card-container">
                <div 
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}
                >
                    <h3 className="card-title">Kundenverwaltung</h3>
                    <Button themeColor="primary" onClick={() => history('/create-customers')}>
                        Kunde hinzufügen
                    </Button>
                </div>
                <div className="card-component">
                    <Form
                        onSubmit={onSubmit}
                        initialValues={{
                            companyName: '',
                            streetName: '',
                            streetNumber: '',
                            PLZ: '',
                            cityName: '',
                            customer: '',
                            firstName: '',
                            lastName: '',
                            function: '',
                            email: '',
                            phoneNumber: '',
                            isInPublicDirectory: false,
                            isPrivateCustomer: false,
                        }}
                        render={(formRenderProps) => (
                            <FormElement horizontal={true} style={{ maxWidth: 700 }}>
                                <Field
                                    id={'companyName'}
                                    name={'companyName'}
                                    label={'Firmenname'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'streetName'}
                                    name={'streetName'}
                                    label={'Strasse'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'streetNumber'}
                                    name={'streetNumber'}
                                    label={'Hausnummer'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'PLZ'}
                                    name={'PLZ'}
                                    label={'PLZ'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'cityName'}
                                    name={'cityName'}
                                    label={'Stadt'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'customer'}
                                    name={'customer'}
                                    label={'Anrede'}
                                    component={DropDownList}
                                    data={title}
                                />
                                <Field
                                    id={'firstName'}
                                    name={'firstName'}
                                    label={'Vorname'}
                                    component={Input}
                                />
                                <Field
                                    id={'lastName'}
                                    name={'lastName'}
                                    label={'Nachname'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'function'}
                                    name={'function'}
                                    label={'Funktion'}
                                    component={Input}
                                />
                                <Field
                                    id={'email'}
                                    name={'email'}
                                    type={'email'}
                                    placeholder={'e.g.: peter@gmail.com'}
                                    label={'E-Mail'}
                                    component={Input}
                                />
                                <Field
                                    id={'phoneNumber'}
                                    name={'phoneNumber'}
                                    label={'Telefonnummer'}
                                    component={MaskedTextBox}
                                />
                                <Field
                                    labelId={'isInPublicDirectoryLabel'}
                                    name={'isInPublicDirectory'}
                                    label={'Kunde aktiv'}
                                    component={Switch}
                                />
                                <Field
                                    labelId={'isPrivateCustomerLabel'}
                                    name={'isPrivateCustomer'}
                                    label={'Privatkunde'}
                                    component={Switch}
                                    onChange={(event) => handlePrivateCustomerChange(event, formRenderProps)}
                                />
                                <hr />
                                <div className={'k-form-buttons'}>
                                    <Button onClick={onCancelClick}>
                                        Abbrechen
                                    </Button>
                                    <Button
                                        themeColor={"primary"}
                                        type={'submit'}
                                        disabled={!formRenderProps.allowSubmit}
                                    >
                                        Speichern
                                    </Button>
                                </div>
                            </FormElement>
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

export default CreateCustomers;